/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterKindListViewModel } from '../../models/setup-parameter-kind-list-view-model';

export interface GetSetupParameterKindById$Params {
  setupParameterKindId: number;
}

export function getSetupParameterKindById(http: HttpClient, rootUrl: string, params: GetSetupParameterKindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterKindListViewModel>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterKindById.PATH, 'get');
  if (params) {
    rb.path('setupParameterKindId', params.setupParameterKindId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameterKindListViewModel>;
    })
  );
}

getSetupParameterKindById.PATH = '/api/v1/SetupParameter/GetSetupParameterKindById/{setupParameterKindId}';
